import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

const ManualUpdateModal = ({ show, onHide, onConfirm, loading = false }) => {
    const [files, setFiles] = useState({
        entregas: null,
        trl_crl_datas: null,
        orcamento_resumo: null
    });
    const [logMessage, setLogMessage] = useState('');

    const handleFileChange = (field, file) => {
        setFiles(prev => ({ ...prev, [field]: file }));
    };

    const handleConfirm = async () => {
        // Validar se todos os arquivos foram selecionados
        if (!files.entregas || !files.trl_crl_datas || !files.orcamento_resumo) {
            alert('Por favor, selecione todos os 3 arquivos CSV antes de confirmar.');
            return;
        }

        try {
            await onConfirm(files, logMessage.trim());
            // Limpar arquivos e mensagem após sucesso
            setFiles({
                entregas: null,
                trl_crl_datas: null,
                orcamento_resumo: null
            });
            setLogMessage('');
            onHide();
        } catch (error) {
            console.error('Error in manual update:', error);
        }
    };

    const handleClose = () => {
        // Limpar arquivos e mensagem ao fechar
        setFiles({
            entregas: null,
            trl_crl_datas: null,
            orcamento_resumo: null
        });
        setLogMessage('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            {/* Header with alert icon */}
            <Modal.Header className='bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 flex items-center' style={{
                backgroundColor: '#6c757d',
                color: 'white',
                padding: '12px 20px',
                borderRadius: '8px 8px 0 0',
                marginBottom: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <span style={{ fontWeight: 'bold' }}>Alerta</span>
                <FaExclamationTriangle />
            </Modal.Header>

            <Modal.Body style={{ padding: '40px 60px' }}>
                {/* File input container */}
                <div style={{
                    border: '2px solid #ccc',
                    borderRadius: '8px',
                    padding: '30px',
                    marginBottom: '30px',
                    backgroundColor: '#f9f9f9'
                }}>
                    {/* File input 1: entregas.csv */}
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                            Escolher arquivo entregas.csv
                        </label>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <input
                                type="file"
                                id="entregas"
                                accept=".csv"
                                onChange={(e) => handleFileChange('entregas', e.target.files[0])}
                                disabled={loading}
                                style={{ display: 'none' }}
                            />
                            <div
                                style={{
                                    flex: 1,
                                    padding: '8px 12px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    fontSize: '14px',
                                    minHeight: '38px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {files.entregas ? files.entregas.name : ''}
                            </div>
                            <Button
                                onClick={() => document.getElementById('entregas').click()}
                                disabled={loading}
                                style={{
                                    backgroundColor: '#003B6B',
                                    borderColor: '#003B6B',
                                    padding: '8px 25px',
                                    fontWeight: 'bold',
                                    borderRadius: '8px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                Inserir
                            </Button>
                        </div>
                    </div>

                    {/* File input 2: trl_crl_datas.csv */}
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                            Escolher arquivo trl_crl_datas.csv
                        </label>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <input
                                type="file"
                                id="trl_crl_datas"
                                accept=".csv"
                                onChange={(e) => handleFileChange('trl_crl_datas', e.target.files[0])}
                                disabled={loading}
                                style={{ display: 'none' }}
                            />
                            <div
                                style={{
                                    flex: 1,
                                    padding: '8px 12px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    fontSize: '14px',
                                    minHeight: '38px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {files.trl_crl_datas ? files.trl_crl_datas.name : ''}
                            </div>
                            <Button
                                onClick={() => document.getElementById('trl_crl_datas').click()}
                                disabled={loading}
                                style={{
                                    backgroundColor: '#003B6B',
                                    borderColor: '#003B6B',
                                    padding: '8px 25px',
                                    fontWeight: 'bold',
                                    borderRadius: '8px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                Inserir
                            </Button>
                        </div>
                    </div>

                    {/* File input 3: orcamento_resumo.csv */}
                    <div>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                            Escolher arquivo orcamento_resumo.csv
                        </label>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <input
                                type="file"
                                id="orcamento_resumo"
                                accept=".csv"
                                onChange={(e) => handleFileChange('orcamento_resumo', e.target.files[0])}
                                disabled={loading}
                                style={{ display: 'none' }}
                            />
                            <div
                                style={{
                                    flex: 1,
                                    padding: '8px 12px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    fontSize: '14px',
                                    minHeight: '38px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {files.orcamento_resumo ? files.orcamento_resumo.name : ''}
                            </div>
                            <Button
                                onClick={() => document.getElementById('orcamento_resumo').click()}
                                disabled={loading}
                                style={{
                                    backgroundColor: '#003B6B',
                                    borderColor: '#003B6B',
                                    padding: '8px 25px',
                                    fontWeight: 'bold',
                                    borderRadius: '8px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                Inserir
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Explanation text */}
                <div style={{
                    textAlign: 'center',
                    marginBottom: '30px',
                    lineHeight: '1.8'
                }}>
                    <p style={{ margin: '0 0 20px 0', fontSize: '15px' }}>
                        O banco de dados analisado será atualizado a partir dos arquivos inseridos.<br />
                        Essa operação pode levar algum tempo para ser concluída.
                    </p>
                    <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold' }}>
                        Confirmar operação?
                    </p>
                </div>

                {/* Log message input */}
                <div style={{ marginBottom: '30px', textAlign: 'left' }}>
                    <label style={{
                        display: 'block',
                        marginBottom: '8px',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'center'
                    }}>
                        Mensagem de log (opcional)
                    </label>
                    <Form.Control
                        type="text"
                        value={logMessage}
                        onChange={(e) => setLogMessage(e.target.value)}
                        placeholder="Digite uma mensagem para registrar no log..."
                        disabled={loading}
                        style={{
                            borderRadius: '8px',
                            padding: '12px',
                            fontSize: '14px'
                        }}
                    />
                </div>

                {/* Action buttons */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                    <Button
                        onClick={handleClose}
                        disabled={loading}
                        style={{
                            backgroundColor: '#dc3545',
                            borderColor: '#dc3545',
                            padding: '12px 50px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '150px',
                            fontSize: '16px'
                        }}
                    >
                        Voltar
                    </Button>

                    <Button
                        onClick={handleConfirm}
                        disabled={loading || !files.entregas || !files.trl_crl_datas || !files.orcamento_resumo}
                        style={{
                            backgroundColor: '#003B6B',
                            borderColor: '#003B6B',
                            padding: '12px 50px',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            minWidth: '150px',
                            fontSize: '16px',
                            opacity: (!files.entregas || !files.trl_crl_datas || !files.orcamento_resumo) ? 0.5 : 1
                        }}
                    >
                        {loading ? 'Processando...' : 'Confirmar'}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ManualUpdateModal;